!function (i) {
    "use strict";

    function e() {
        var o = document.querySelector(".scroll-progress path"), n = o.getTotalLength();
        o.style.transition = o.style.WebkitTransition = "none", o.style.strokeDasharray = n + " " + n, o.style.strokeDashoffset = n, o.getBoundingClientRect(), o.style.transition = o.style.WebkitTransition = "stroke-dashoffset 10ms linear";

        function e() {
            var e = i(window).scrollTop(), s = i(document).height() - i(window).height();
            o.style.strokeDashoffset = n - e * n / s
        }

        e(), i(window).scroll(e);
        jQuery(window).on("scroll", function () {
            50 < jQuery(this).scrollTop() ? jQuery(".scroll-progress").addClass("active-progress") : jQuery(".scroll-progress").removeClass("active-progress")
        }), jQuery(".scroll-progress").on("click", function (e) {
            return e.preventDefault(), jQuery("html, body").animate({scrollTop: 0}, 500), !1
        })
    }

    function n() {
        i(".has-anim").each(function () {
            var e, s, o, n;
            !0 === (e = this, s = i(window).scrollTop(), o = s + i(window).height(), (n = i(e).offset().top) + i(e).height() / 4 <= o && s <= n) && i(this).addClass("visible")
        })
    }

    i(document).ready(function () {
        var s;
        s = 0, window.onscroll = function () {
            var e = document.documentElement.scrollTop || document.body.scrollTop;
            110 < e ? (s <= e ? (s = e, i(".navigation").addClass("header-unpinned")) : (s = e, i(".navigation").removeClass("header-unpinned"))) :  (s = e)
        }, i('[data-toggle="navbar-menu"]').on("click", function () {
            i(this).attr("data-navbar", "visible"), i(".navigation").addClass("visible"), i("#navbar-menu").addClass("show"), i(".sidenav-overlay").addClass("show")
        }), i('[data-toggle="navbar-menu-close"], .sidenav-overlay').on("click", function () {
            i('[data-toggle="navbar-menu"]').attr("data-navbar", "hidden"), i(".navigation").removeClass("visible"), i("#navbar-menu").removeClass("show"), i(".sidenav-overlay").removeClass("show")
        }), e(), i(window).scroll(function () {
            n()
        })
    }), i(window).on("load", function () {
        n()
    })

    window.addEventListener('load',function(){
        document.querySelector('body').classList.add("loaded")
    });
}(jQuery);